import React from 'react'
import classNames from 'classnames'

const InputWrapper = ({
  iconLeft,
  error,
  iconRight,
  label,
  handleError = true,
  children,
  classes = {},
}) => {
  return (
    <div className={classNames(handleError && 'pb-2 ', 'w-full')}>
      {label && (
        <div className="text-blue-650 text-md font-bold mb-2.5  text-left">
          {label}
        </div>
      )}
      <div className="flex justify-center items-center relative">
        {iconLeft && (
          <div
            className={classNames(
              'absolute inset-y-0 left-5 flex items-center justify-center',
              classes.iconsLeft,
            )}
          >
            {iconLeft}
          </div>
        )}
        {children}
        {iconRight && (
          <div
            className={classNames(
              'absolute inset-y-0 right-5 flex items-center justify-center',
              classes.iconRight,
            )}
          >
            <button type="button" className="focus:outline-none ">
              {iconRight}
            </button>
          </div>
        )}
      </div>
      {handleError && error && (
        <div
          className={classNames(
            '2xl:text-xs mt-1.5 text-sm h-5 relative left-1 sm:text-10',
            `text-[#DC143C]`,
          )}
        >
          {error}
        </div>
      )}
    </div>
  )
}

export default InputWrapper
